
export const UPLOAD_CONFIG = {
  MAX_IMAGE_SIZE: 2 * 1024 * 1024, // 2MB
  MAX_PDF_SIZE: 5 * 1024 * 1024,   // 5MB
  ACCEPTED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/webp'] as const,
  ACCEPTED_PDF_TYPES: ['application/pdf'] as const
} as const;

export type AcceptedImageType = typeof UPLOAD_CONFIG.ACCEPTED_IMAGE_TYPES[number];
export type AcceptedPdfType = typeof UPLOAD_CONFIG.ACCEPTED_PDF_TYPES[number];
export type AcceptedFileType = AcceptedImageType | AcceptedPdfType;

export type UploadConfig = typeof UPLOAD_CONFIG;
